import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";


const CellCount = () => {
    const config = {
        headers: {
            Authorization: `Bearer eyJhbGciOiJIUzI1NiJ9.ewogICAgImp0aSI6ICI4ZTc1ZDlhZi04NmMwLTQyYTUtODRhZC1jMGRiMGU0OGM0NGQiLAogICAgInZhbGlkIjogIjEiLAogICAgImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL25hbWVpZGVudGlmaWVyIjogImY2MTA4YzEwLTQ1YjEtNDE3Yy1iZDk2LTM4MjY4NTM2ZTUxYiIsCiAgICAiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvbmFtZSI6ICJ0ZXN0dXNlckB0ZXN0LmNvbSIsCiAgICAiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvZ2l2ZW5uYW1lIjogIlRlc3QgVXNlciIsCiAgICAib3JnYW5pemF0aW9uIjogIlRlc3QgU3ViY29uIiwKICAgICJzdWJjb250cmFjdG9ySWQiOiAiNCIsCiAgICAidmVuZG9ySWQiOiAiIiwKICAgICJvcGVyYXRvcklkIjogIiIsCiAgICAiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9yb2xlIjogIlN1YmNvbnRyYWN0b3IiLAogICAgImlzcyI6ICJodHRwOi8vc2VnYWwtc3R1ZGlvcy5jb20iLAogICAgImF1ZCI6ICJodHRwOi8vc2VnYWwtc3R1ZGlvcy5jb20iCiAgfQ.D-yDO3T42KF0oLYoxs4QwwOgr0dyLc3wHeTQjGvS7z8`
        }
    }
    const chartRef = useRef(null);
    const [cellCount3GData, setCellCount3GData] = useState([]);
    const [customXAxis, setCustomXAxis] = useState([]);
    const [cellCount4GData, setCellCount4GData] = useState([]);
    const startDate = new Date(new Date() - (7 * 86400000));
    const [lines, setLines] = useState({
        left1: [{
            color: 'red',
            dashStyle: 'solid',
            value: 100,
            width: 2,
        },], left2: [], right1: [], right2: [], bottom1: [], bottom2: []
    });
    const options = {
        exporting: {
            enabled: true,
            width: 1920
        },
        title: {
            text: "",
            align: 'left'
        },
        chart: {
            zoomType: "xy",
            style: {
                height: "100%"
            },
            exporting: {
                enabled: false,
            },
        },
        credits: {
            enabled: false,
        },
        plotOptions: {
            line: {
                lineWidth: 2,
                states: {
                    hover: {
                        lineWidth: 3,
                    },
                    color: {
                        color: "red"
                    }
                },
                marker: {
                    enabled: false,
                },
            },

            series: {
                allowPointSelect: true,
                softThreshold: false,
            },
            // pointInterval: 180000, // half hour
            pointStart: 2010
            // pointStart: startDate

        },
        time: {
            timezoneOffset: -270,
        },
        yAxis: {
            title: {
                enabled: false,
            },
            // {
            //     id: "left1",
            //     plotLines: lines["left1"],
            //     lineWidth: 1,
            //     title: {
            //         enabled: false,
            //     }
            // },
            // {
            //     id: "left2",
            //     plotLines: lines["left2"],
            //     title: {
            //         enabled: false,
            //     },
            // },
            // {
            //     id: "right1",
            //     plotLines: lines["right1"],
            //     lineWidth: 1,
            //     opposite: true,
            //     title: {
            //         enabled: false,
            //     },
            // },
            // {
            //     id: "right2",
            //     plotLines: lines["right2"],
            //     lineWidth: 0,
            //     opposite: true,
            //     title: {
            //         enabled: false,
            //     },
            // },
        },
        xAxis: {
            // {
            // accessibility: {
            //     rangeDescription: 'Range: 2010 to 2020'
            // },
            // labels: {
            //     style: { fontWeight: "bold" },
            //     rotation: -75,
            //     // format: ""
            // },


            categories: customXAxis,
            // id: "bottom1",
            // type: "datetime",
            // labels: {
            //     style: { fontWeight: "bold" },
            //     rotation: 90,
            //     // format: ""
            // },
            // lineWidth: 1,

            // plotLines: lines["bottom1"],
            // title: {
            //     enabled: false,
            // },
            // },
            // {
            //     id: "bottom2",
            //     type: "datetime",
            //     labels: {
            //         style: { fontWeight: "bold" },
            //         rotation: 90,
            //         // format: ""
            //     },
            //     lineWidth: 1,
            //     plotLines: lines["bottom2"],
            //     title: {
            //         enabled: false,
            //     },
            // },
        },
        tooltip: {
            shared: false,
            crosshairs: true,
        },

        series: [
            {
                name: "Cell Count 3G",
                // data: [12, 14, 17],
                data: cellCount3GData,
            },
            {
                name: "Cell Count 4G",
                // data: [34, 23, 12],
                data: cellCount4GData,
            },
        ],
    };

    useEffect(() => {
        axios
            .get("/v1/pm/rightel/cellCount3G", config)
            .then((response) => {
                const my_response = [...response.data];
                my_response
                    .sort((a, b) => {
                        const DateA = a.DATE.toLowerCase();
                        const DateB = b.DATE.toLowerCase();
                        if (DateA < DateB) return 1;
                        if (DateA > DateB) return -1;
                        return 0;
                    })
                    .reverse();
                const transformedData = [];
                const timeSeries = [];
                for (let element of my_response) {
                    timeSeries.push(element.DATE)
                    // transformedData.push({
                    //     Cell_Count: element.Cell_Count,
                    //     DATE: element.DATE,
                    //     // TIME: element.TIME
                    // })
                    transformedData.push(element.Cell_Count)
                }
                // for (let jax of transformedData) console.log(jax);
                setCellCount3GData(transformedData);
                setCustomXAxis(timeSeries)
            })
            .catch((error) => {
                console.error("Error fetching cellCount3G data:", error);
            });

        axios
            .get("/v1/pm/rightel/cellCount4G", config)
            .then((response) => {
                const my_response = [...response.data];
                my_response
                    .sort((a, b) => {
                        const DateA = a.DATE.toLowerCase();
                        const DateB = b.DATE.toLowerCase();
                        if (DateA < DateB) return 1;
                        if (DateA > DateB) return -1;
                        return 0;
                    })
                    .reverse();
                const transformedData = [];
                const timeSeries = [];
                for (let element of my_response) {
                    timeSeries.push(element.DATE)
                    // transformedData.push({
                    //     Cell_Count: element.Cell_Count,
                    //     DATE: element.DATE,
                    //     // TIME: element.TIME
                    // })
                    transformedData.push(element.Cell_Count)
                }
                // for (let jax of transformedData) console.log(jax);
                setCellCount4GData(transformedData);
            })
            .catch((error) => {
                console.error("Error fetching cellCount4G data:", error);
            });
    }, []);



    return (
        <div>
            <div className="font-light text-lg text-gray-700 tracking-wide">
                <h5 >Cell Count</h5>
            </div>
            <HighchartsReact
                ref={chartRef}
                highcharts={Highcharts}
                options={options}
            />
        </div>
    );
};


export default CellCount;